const CONFIG_ATTRIBUTES = {
  AUTH_CALLBACK_URL: 'AUTH_CALLBACK_URL',
  CLIENT_ID: 'CLIENT_ID',
  SCOPE: 'SCOPE',
  AUTHORIZATION_URL: 'AUTHORIZATION_URL',
  CHANGE_PASSWORD_URL: 'CHANGE_PASSWORD_URL',
  CHANGE_MULTIFACTORAUTHENTICATION_URL: 'CHANGE_MULTIFACTORAUTHENTICATION_URL',
  LOGOUT_URL: 'LOGOUT_URL',
  LOGGED_OUT_REDIRECT_URL: 'LOGGED_OUT_REDIRECT_URL',
  OAUTH_PROVIDER: 'OAUTH_PROVIDER',
  MINESIDER_BACKEND_URL: 'MINESIDER_BACKEND_URL',
  ENTERPRISE_REDIRECT_URL: 'ENTERPRISE_REDIRECT_URL',
  MAINTENANCE_URL: 'MAINTENANCE_URL',
  GTM_ID: 'GTM_ID',
  CI360_TENANT_SHORT_NAME: 'CI360_TENANT_SHORT_NAME',
  CI360_TENANT_ID: 'CI360_TENANT_ID',
  SENTRY_ENABLED: 'SENTRY_TOGGLE',
  SENTRY_DSN: 'SENTRY_DSN',
  SENTRY_TRACING_RATE: 'SENTRY_TRACING_RATE',
  PUPPET_ENVIRONMENT: 'PUPPET_ENVIRONMENT',
  LYSE_RELOCATION_URL: 'LYSE_RELOCATION_URL',
  LYSE_INVOICE_URL: 'LYSE_INVOICE_URL',
  LYSE_CONSENT_URL: 'LYSE_CONSENT_URL',
  LOCIZE_PROJECT_ID: 'LOCIZE_PROJECT_ID',
  LOCIZE_API_KEY: 'LOCIZE_API_KEY',
  LOCIZE_VERSION: 'LOCIZE_VERSION',
  USERINFORMATION_VERIFICATION_FETCH_TIMEOUT: 'USERINFORMATION_VERIFICATION_FETCH_TIMEOUT',
  ECOM_BROADBAND_WIDGET_DATA_URL: 'ECOM_BROADBAND_WIDGET_DATA_URL',
  ECOM_BROADBAND_WIDGET_REDIRECT_URL: 'ECOM_BROADBAND_WIDGET_REDIRECT_URL',
  ORDER_TRACKER_URL: 'ORDER_TRACKER_URL',
  TEST_USER_PW: 'TEST_USER_PW',
  VOIP_API_BASE_URL: 'VOIP_API_BASE_URL',
  AZURE_DOMAIN: 'AZURE_DOMAIN',
  ARIA_URL: 'ARIA_URL',
};

export { CONFIG_ATTRIBUTES };
